import _ from "lodash";

export default function remOrAddToArr(arr: any[], val: any) {
	if (arr.includes(val)) {
		_.remove(arr, (v) => v === val);
	} else {
		arr.push(val);
	}
}
